import React from "react";
import { FC } from "react";
import classNames from "classnames";
import { SbGatsbyStory, useStoryblokState } from "gatsby-source-storyblok";
import { BlockBody } from "../common/block-body/BlockBody";
import { RichText } from "../base-page/models";

type PageContent = {
  content: {
    heroTitle: string;
    text: RichText;
  };
};

type Props = {
  content: SbGatsbyStory;
};

export const LegalContentPage: FC<Props> = ({ content }) => {
  const entry = useStoryblokState(content) as unknown as PageContent;
  const { heroTitle, text } = entry.content;

  return (
    <div
      className={classNames(
        "mb-15 flex justify-center px-5",
        "md:mb-25",
        "lg:px-16",
        "xl:mb-40 xl:px-24",
      )}
    >
      <div
        className={classNames(
          "flex w-full justify-center",
          "xl:max-w-container",
        )}
      >
        <div className={classNames("w-full", "lg:w-10/12")}>
          <div
            className={classNames(
              "pb-15 pt-40",
              "md:pb-25",
              "lg:pt-60",
              "xl:pb-40",
            )}
          >
            <h1
              className={classNames(
                "text-large text-primary-content",
                "md:text-xx-large",
                "xl:text-center xl:text-huge",
              )}
            >
              {heroTitle}
            </h1>
          </div>
          <div className="prose !prose-neutral max-w-none text-regular text-base-400 prose-headings:text-base-100 prose-blockquote:text-base-400">
            <BlockBody richText={text} />
          </div>
        </div>
      </div>
    </div>
  );
};
